export default "__VITE_ASSET__ZAEmOSNg__"